import { useCallback } from "react";

// Module singletons: `useRef(new Audio(src))` created (and discarded) three
// media elements on every render of every caller.
const TEEN_SOUND = new Audio("/sounds/teen-message.mp3");
const OPS_SOUND = new Audio("/sounds/ops-message.mp3");
const WARNING_SOUND = new Audio("/notification.mp3");

const playSound = (audio: HTMLAudioElement) => {
  audio.currentTime = 0;
  audio.play().catch((error: Error) => {
    if (error.name === "NotAllowedError") {
      console.log("Autoplay prevented - waiting for user interaction");
    } else {
      console.error("Error playing message notification:", error);
    }
  });
};

export function useMessageNotificationSound() {
  const playTeenMessageSound = useCallback(() => playSound(TEEN_SOUND), []);
  const playOpsMessageSound = useCallback(() => playSound(OPS_SOUND), []);
  const playWarningSound = useCallback(() => playSound(WARNING_SOUND), []);

  return {
    playTeenMessageSound,
    playOpsMessageSound,
    playWarningSound,
  };
}
